import { Component } from 'react';
import QuickReplyList from '../../containers/QuickReplyList';
import type { Button, ImageWithButtonsData } from '../../types/ChatWindow';
import type { MessageScheme } from '../../types/configs';

class ButtonedImageMessage extends Component<
  {
    data: ImageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  },
  { buttonClicked: boolean }
> {
  constructor(props: {
    data: ImageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  }) {
    super(props);
    this.state = {
      buttonClicked: false,
    };
  }

  handleClick = (clickedButton: Button) => {
    const { submitHandler } = this.props;
    submitHandler({ value: clickedButton });
    this.setState({
      buttonClicked: true,
    });
  };

  render() {
    const { buttonClicked } = this.state;
    const {
      data: { image, buttons },
      scheme,
    } = this.props;
    return (
      <>
        <img src={image} alt='' width='200px' />
        {buttonClicked ? null : (
          <QuickReplyList
            buttons={buttons}
            onClick={this.handleClick}
            scheme={scheme}
          />
        )}
      </>
    );
  }
}

export default ButtonedImageMessage;
